import React from 'react';
import { Tab, Tabs, Tooltip } from '@material-ui/core';

import cx from 'classnames';
import CardWrapper from '../../../components/UI/CardWrapper/CardWrapper';
import PaperUI from '../../../components/UI/Paper/PaperUI';

import useStyles from './TabCardLayout.styles';
import LoadingUI from '../../../components/UI/Loading/LoadingUI';


function TabCardLayout({
  children,
  separate = false,
  showLoading = false,
  heightContainer = '60vh',
  tabItems,
  parentStates,
  footerComponent = null,
  devedorWarnings = [],
  visibilidadePreferencias = [],
  style = {},
}) {
  const styleDefault = useStyles();

  const styles = { ...styleDefault, ...style };

  const [value, setValue] = parentStates;

  const classes = cx({ [styles.separator]: separate, [styles.bsNone]: !separate });

  const tabChangeHandler = (event, newValue) => {
    setValue(newValue);
  };
  const content = React.Children.toArray(children).filter(child => child !== false);
  return (
    <>
      <LoadingUI show={showLoading} />
      <PaperUI className={classes}>
        <div className={styles.appBar}>
          <Tabs
            value={value}
            onChange={tabChangeHandler}
            classes={{ indicator: styles.tabSelectColor }}
            variant="scrollable"
            scrollButtons="auto"
          >
            {tabItems.map((item) => {
              if (item) {
                if (visibilidadePreferencias[item.indexHidden] === false) {
                  return <></>;
                }
                return devedorWarnings?.length > 0 && item.index === 3
                  ? (
                    <Tooltip
                      key={item.id}
                      title={(
                        <>
                          <p>
                            Para registrar um boleto:
                            {' '}
                            <br />
                          </p>
                          <ul>
                            {devedorWarnings?.map((warning, idx) => (
                              <li key={idx}>
                                -
                                {' '}
                                {warning}
                              </li>
                            ))}
                          </ul>
                        </>
)}
                      placement="top"
                    >
                      <Tab
                        disabled={item.disabled}
                        className={styles.ajustWhiteSpace}
                        key={item.id}
                        id={item.id}
                        label={item.label}
                        aria-controls={item.ariaControl}
                        style={{ backgroundColor: '#ff6666' }}
                      />
                    </Tooltip>
                  )
                  : (
                    <Tab
                      disabled={item.disabled}
                      className={styles.ajustWhiteSpace}
                      key={item.id}
                      id={item.id}
                      label={item.label}
                      aria-controls={item.ariaControl}
                    />
                  );
              }
              return null;
            })}
          </Tabs>
        </div>
        <CardWrapper height={heightContainer}>{content}</CardWrapper>

        {footerComponent}
      </PaperUI>
    </>
  );
}

export default React.memo(TabCardLayout);
